import Vue from "vue";
import { teamData } from "@/services/index.js";
import Router from "vue-router";
import AuthenticationRoutes from "./auth.js";
import DashboardRoutes from "./dashboard.js";
import AuthService from "@/components/Auth/services/auth-service";
import { siteAllowedForCampaign7143 } from "@/utils/crossAgencyCampaign7143";
import {
  accessTokenFromPath,
  accountSessionMarker,
  adoptedGuestAccess,
  adoptGuestToken,
  dropGuestTokenForAccountSession,
  guestAccessFromUserId,
  guestSitePath,
  isAccountSessionMarker,
} from "@/utils/guestAccess";

//https://analytics.adx.space
//https://analytics.aheadserver.com.br
//https://analytics.adforce.com.br


let url = window.location.hostname
if(window.location.hostname == 'localhost' || window.location.hostname == 'analytics-v4.adserver.dev'){
    url = 'https://analytics.adx.space'
} else {
    url = window.location.hostname
}

const normalizeBaseUrl = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  try {
    return new URL(value).origin.replace(/\/+$/, "");
  } catch (error) {
    return null;
  }
};

const buildDashboardRedirectUrl = (baseUrl, route, sessionId) => {
  const targetUrl = new URL(route.fullPath || "/dashboard/campaigns", `${baseUrl}/`);

  if (sessionId) {
    targetUrl.searchParams.set("s", sessionId);
  }

  return targetUrl.toString();
};

const getSessionIdFromRoute = (to) => {
  if (isAccountSessionMarker(to?.query?.s)) {
    return to.query.s;
  }

  return accountSessionMarker();
};

function adoptAccountSession(to) {
  const marker = typeof to?.query?.s === "string" ? to.query.s : "";
  if (!isAccountSessionMarker(marker)) return;
  dropGuestTokenForAccountSession();
  window.localStorage.setItem("sessionId", marker);
  if (marker !== "trpc") {
    window.localStorage.setItem("reportsSessionId", marker);
  }
}

const buildRedirectUrlWithSession = (target, sessionId) => {
  if (!target || target === "null") {
    return null;
  }

  try {
    const redirectUrl = new URL(target, window.location.origin);
    if (sessionId) {
      redirectUrl.searchParams.set("s", sessionId);
    }
    return redirectUrl.toString();
  } catch (error) {
    return null;
  }
};

const extractErrorMessage = (error) => {
  return error?.data?.message || error?.message || "";
};

const DOMAIN_ACCESS_FEEDBACK =
  "Seu usuário não tem acesso a este domínio. Tente entrar pelo Analytics correto do seu adserver.";


// let url = process.env.VUE_APP_URL;

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/analytics/access/:token(.*)",
      meta: { requiresAuth: false },
      redirect(to) {
        const token =
          (typeof to.params.token === "string" && to.params.token) ||
          accessTokenFromPath(to.fullPath) ||
          "";
        const guest = adoptGuestToken(token);
        if (!guest) return "/";
        return guestSitePath(guest);
      },
    },
    {
      path: "*",
      redirect: "/",
      name: "home",
      meta: { requiresAuth: false },
    },
    AuthenticationRoutes,
    DashboardRoutes,
  ],

  scrollBehavior(to, from, savePosition) {
    return {
      x: 0,
      y: 0,
    };
  },
});

const buildLoginRoute = (redirect, withFeedback = false) => ({
  path: "/",
  query: {
    redirect,
    ...(withFeedback ? { feedback: "domain-access", feedbackAt: String(Date.now()) } : {}),
  },
});

function locationPath(value) {
  if (typeof value === "string") return value;
  if (value && typeof value.fullPath === "string") return value.fullPath;
  return null;
}

function consumeGuestAccess(to) {
  const access = to.query && to.query.access;
  if (typeof access !== "string" || access.split(".").length !== 3) return null;
  if (!adoptGuestToken(access)) return null;
  const query = { ...to.query };
  delete query.access;
  return { path: to.path, query, hash: to.hash, replace: true };
}

function handoffLegacyAccess(to) {
  const token =
    accessTokenFromPath(to.fullPath) ||
    accessTokenFromPath(locationPath(to.redirectedFrom)) ||
    accessTokenFromPath(window.location.pathname);
  const guest = adoptGuestToken(token);
  if (!guest) return null;
  const target = guestSitePath(guest);
  if (to.path === target) return null;
  return { path: target, replace: true };
}

router.beforeEach(async (to, from, next) => {
  const legacyHandoff = handoffLegacyAccess(to);
  if (legacyHandoff) return next(legacyHandoff);
  const guestRedirect = consumeGuestAccess(to);
  if (guestRedirect) return next(guestRedirect);
  adoptAccountSession(to);
  if (isAccountSessionMarker(typeof to?.query?.s === "string" ? to.query.s : "")) {
    const query = { ...to.query };
    delete query.s;
    return next({ path: to.path, query, hash: to.hash, replace: true });
  }
  try {
    const variables = { filter: `{ 'team_analytics_url' : '${url}' }` };
    const currentTeam = await teamData(variables);
    if(currentTeam?.team_chat_script){
      eval(currentTeam?.team_chat_script);
      // await window.document.body.insertAdjacentHTML('beforeend',response?.team_chat_script)
    }
    /* TO-DO 
        remover commit direto e deixar somente a chamada da action
    */
    router.app.$store.commit("SET_VISUAL_IDENTITY", currentTeam);
    router.app.$store.dispatch("teamDataModule/setTeamData", currentTeam);

    document.title = currentTeam.team_name + " - " + "Analytics";
  } catch (error) {}
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    adoptAccountSession(to);
    const loginRoute = buildLoginRoute(to.fullPath);
    if (localStorage.sessionId) {
      try {
        const user = await AuthService.loggedUser({
          fetchPolicy: "network-only",
        });

        const currentTeamId = router.app.$store.state.teamData?.team_id;
        const isGlobalTeamUser = Number(user?.team_id) === 1;
        const isTeamOnlyUser = !!user?.team_id && !user?.account_id;
        if (
          !isGlobalTeamUser &&
          isTeamOnlyUser &&
          currentTeamId &&
          Number(user.team_id) !== Number(currentTeamId)
        ) {
          const targetTeam = await teamData({
            filter: `{ 'team_id' : ${Number(user.team_id)} }`,
          });

          const targetBaseUrl = normalizeBaseUrl(targetTeam?.team_analytics_url);
          const currentBaseUrl = normalizeBaseUrl(window.location.origin);
          const currentSessionId = getSessionIdFromRoute(to);

          if (targetBaseUrl && targetBaseUrl !== currentBaseUrl) {
            window.location.href = buildDashboardRedirectUrl(
              targetBaseUrl,
              to,
              currentSessionId
            );
            return;
          }

          localStorage.removeItem("sessionId");
          localStorage.removeItem("redirect");
          return next(loginRoute);
        }
        /* TO-DO 
                    remover commit direto e deixar somente a chamada da action
                */
        router.app.$store.commit("LOGGED_USER", user);
        router.app.$store.dispatch("header/getCountUnreadNotification", user?.count_unread_notifications?.count);
        router.app.$store.dispatch("auth/getUser", user);

        const guest = adoptedGuestAccess() || guestAccessFromUserId(user.user_id);
        if (guest) {
          const routeCampaign = to.params?.campaign_id;
          const routeSite = to.params?.site_id;
          const wrongCampaign = routeCampaign && String(routeCampaign) !== String(guest.campaign_id);
          const wrongSite = routeCampaign && String(routeSite) !== String(guest.site_id);
          if (wrongCampaign || wrongSite) {
            return next({
              name: "SitesView",
              params: {
                campaign_id: String(guest.campaign_id),
                site_id: String(guest.site_id),
              },
              replace: true,
            });
          }
          return next();
        }

        window.localStorage.setItem("redirect", user.redirect);
        const needsDomainRedirect =
          user.redirect !== null &&
          user.redirect !== "null" &&
          (user.campaign_id != to.params.campaign_id || user.site_id != to.params.site_id);

        if (needsDomainRedirect) {
          const redirectUrl = buildRedirectUrlWithSession(
            localStorage.redirect,
            getSessionIdFromRoute(to)
          );

          if (redirectUrl) {
            window.location.href = redirectUrl;
            return;
          }
        }

        const crossAgencyCampaignId = to.params?.campaign_id;
        const crossAgencySiteId = to.params?.site_id;
        if (
          crossAgencyCampaignId &&
          crossAgencySiteId &&
          !siteAllowedForCampaign7143(
            Number(crossAgencyCampaignId),
            user.account_id,
            Number(crossAgencySiteId)
          )
        ) {
          return next({
            name: "SingleCampaign",
            params: { campaign_id: String(crossAgencyCampaignId) },
            replace: true,
          });
        }

        return next();
      } catch (error) {
        const errorMessage = extractErrorMessage(error);

        if (errorMessage.includes("Usuário não autorizado para este domínio")) {
          localStorage.removeItem("sessionId");
          localStorage.removeItem("redirect");
          window.sessionStorage.setItem(
            "loginFeedback",
            DOMAIN_ACCESS_FEEDBACK
          );
          return next(buildLoginRoute(to.fullPath, true));
        }

        return next(loginRoute);
      }
    }
    return next(loginRoute);
  }
  return next();
});

export default router;

Vue.use(Router);
